import { variables } from '@kata-kit/theme';

export const defaultTheme = {
  backgroundColor: variables.colors.gray10,
  textColor: variables.colors.gray80,
  borderColor: variables.colors.gray30
};

const themes = {
  defaultTheme
};

export default themes;
